<template>
  <div class="auth-form-container">
    <el-card class="auth-form-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span style="font-size: 18px;">企业认证信息填写</span>
      </div>
      
      <el-form :model="authForm" :rules="rules" ref="authForm" label-width="120px">
        
        
        <el-form-item label="企业名称" prop="companyName">
          <el-input v-model="authForm.companyName" placeholder="请输入企业全称"></el-input>
        </el-form-item>
        
        <el-form-item label="统一社会信用代码" prop="companyCode">
          <el-input v-model="authForm.companyCode" placeholder="请输入18位统一社会信用代码"></el-input>
        </el-form-item>
        
        <el-form-item label="法人代表" prop="legalPerson">
          <el-input v-model="authForm.legalPerson" placeholder="请输入法人姓名"></el-input>
        </el-form-item>


        <el-form-item label="企业的Logo" prop="companyLogo" label-width="140px">

          <el-upload class="avatar-uploader" :http-request="uploadFile" accept=".jpg, .png" action=""
            :show-file-list="false" :before-upload="beforeAvatarUpload">
            <img v-if="authForm.companyLogo" :src="authForm.companyLogo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        
        
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交认证</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AuthForm',
  data() {
    return {
      authForm: {
        companyName: '',
        companyCode: '',
        legalPerson: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        companyCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { pattern: /^[0-9A-Z]{18}$/, message: '请输入18位有效的统一社会信用代码', trigger: 'blur' }
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.authForm.validate(valid => {
        if (valid) {
          // 提交认证逻辑
          this.$message.success('认证信息提交成功，请等待审核')
          this.$router.push('/home')
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.authForm.resetFields()
    }
  }
}
</script>

<style>
.auth-form-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}
.auth-form-card {
  margin-top: 20px;
}

.item {
  float: left;
  /* 或者 right，取决于你想要哪个元素在左边或右边 */
  width: 50%;
  /* 或者具体的像素值，确保两个div加起来等于父容器的宽度 */
}

.container::after {
  content: "";
  clear: both;
  /* 清除浮动 */
  display: table;
  /* 为了确保清除有效 */
}

.w-e-text-container {
  background-color: white;
  height: 450px !important;
}

.editor {
  margin-top: 40px;
  /*position: relative;
        margin-top: 200px;*/
}

.form-item {
  width: 400px;
  clear: both;
  /* 清除浮动 */
}

.board-form {
  margin-top: 20px;
}

.card-body {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0;
}
</style>
<style scoped>
.card-content {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #999;
  padding: 0 20px;
}

.card-num {
  font-size: 30px;
}

.card-icon {
  font-size: 50px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #fff;
}

.bg1 {
  background: #2d8cf0;
}

.bg2 {
  background: #64d572;
}

.bg3 {
  background: #f25e43;
}

.bg4 {
  background: #e9a745;
}

.color1 {
  color: #2d8cf0;
}

.color2 {
  color: #64d572;
}

.color3 {
  color: #f25e43;
}

.color4 {
  color: #e9a745;
}

.chart {
  width: 100%;
  height: 400px;
}

.card-header {
  padding-left: 10px;
  margin-bottom: 20px;
}

.card-header-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.card-header-desc {
  font-size: 14px;
  color: #999;
}

.timeline-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #000;
}

.timeline-time,
.timeline-desc {
  font-size: 12px;
  color: #787878;
}

.rank-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.rank-item-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f2f2f2;
  text-align: center;
  line-height: 40px;
  margin-right: 10px;
}

.rank-item-content {
  flex: 1;
}

.rank-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #343434;
  margin-bottom: 10px;
}

.rank-item-desc {
  font-size: 14px;
  color: #999;
}

.map-chart {
  width: 100%;
}

.paragraph-style {
  margin-bottom: 6px;
}

.div-style {
  margin-top: 20px;
}

.left-aligned-black-text {
  color: black;
  text-align: left;
  /* 通常text-align默认为left，但明确指定也无妨 */
}

.paragraph-style {
  margin-bottom: 6px;
}

.label-left {
  text-align: left !important;
  /* 使用!important确保覆盖默认样式 */
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>